// File names that GAMMIS will accept.
//
// The Georgia Medicaid portal refuses an upload whose name has anything
// outside  A-Z a-z 0-9 . + @ % ~ ' _ - $ [ ] ( ) !  — no spaces, no en
// dashes, no "·". Every document CAERA files (signed appendices, faxes,
// certificates, reports) may end up uploaded there, so every generated name
// follows one rule:
//
//   no spaces — every space becomes "_", parts are joined by "_", anything
//   else outside the allowed set is dropped. Hyphens survive only where the
//   source had them (dates, hyphenated names).
//
//   G109_2026-09_Appendix_R_signed.pdf
//   G109_2026-09-14_PPOT_Childrens_Healthcare.pdf
//   G109_2026-09_Signature_certificate_Family_forms_transfer.pdf
//
// The same rule lives in supabase/functions/_shared/fax-common.ts for the
// fax pipeline; keep the two in step.

const ALLOWED = /[^A-Za-z0-9.+@%~'_\-$[\]()!]/g;

// One part of a name: "Appendix R" → "Appendix_R", "1st renewal · Sep 2026" → "1st_renewal_Sep_2026".
export function namePart(s, max = 60) {
  const t = String(s ?? '')
    .normalize('NFKD').replace(/[\u0300-\u036f]/g, '')   // é → e
    .replace(/[\u2013\u2014\u00b7\u2022:/\\]+/g, ' ')    // – — · • : / \ → space
    .replace(/[&]/g, ' and ')
    .replace(/\s+/g, ' ').trim()
    .replace(/ /g, '_')
    .replace(ALLOWED, '')
    .replace(/_{2,}/g, '_').replace(/^[_-]+|[_-]+$/g, '');
  if (t.length <= max) return t;
  const cut = t.slice(0, max);
  return t[max] === '_' ? cut : cut.replace(/_[^_]*$/, '');   // finish on a whole word
}

// Whole name: parts joined by "_", extension added.
export function fileName(parts, ext = 'pdf') {
  const body = parts.map((p) => namePart(p)).filter(Boolean).join('_') || 'document';
  return `${body}.${ext.replace(/^\./, '')}`;
}

// Is a name (a user's upload, say) already acceptable to GAMMIS?
export const isGammisSafe = (name) => !ALLOWED.test(String(name || ''));
